var _g, _path, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201.787,
    height: 201.373,
    viewBox: "0 0 53.39 53.28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    paintOrder: "stroke fill markers"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.704,
    d: "M6.36 6.239h40.869v40.784H6.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.111 6.32L6.621 46.93h40.49z",
    fill: "#fff",
    strokeWidth: 2.604
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.465,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    paintOrder: "stroke fill markers",
    d: "M14.533 10.592h24.154v7.167H14.533z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.664 42.422h8.989V31.59h15.044v-6.964H14.665z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.963 24.614L14.604 39.056v3.353h8.99V31.577h15.043v-6.963z",
    strokeWidth: 0.265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.736 14.966l-2.842 2.797h2.842z",
    strokeWidth: 0.374,
    paintOrder: "stroke fill markers"
  }))));
}
export default SvgSwitchColorIcon;